<div class="eau-loader-launcher--bg"></div>
<div class="eau-loader-launcher--icon"></div>
<div class="eau-loader-launcher--brand">{{title}}</div>
<eau-loader-spinner></eau-loader-spinner>